import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFoundPage() {
  return (
    <main
      data-testid="not-found-page"
      className="min-h-screen flex items-center justify-center px-6 bg-slate-950 text-slate-100"
    >
      <div className="text-center max-w-lg">
        <div className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono mb-4">
          / 404
        </div>
        <h1 className="text-6xl md:text-7xl font-medium tracking-tighter text-slate-50 mb-5">
          Page not found.
        </h1>
        <p className="text-slate-400 mb-8">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link to="/">
          <Button className="bg-cyan-400 text-slate-950 hover:bg-cyan-300 rounded-none font-semibold h-12 px-7 btn-glow">
            Back to Home
          </Button>
        </Link>
      </div>
    </main>
  );
}
